<template>
  <div class="sub_wrapper" :class="{shadowUp: picked_sub && (sub._id == picked_sub._id)}" draggable="true" @dragstart="startDragSub($event, sub)">
    <div class="sub pointer">
      <v-icon size="22" @click="toggleCompletedSub()" @mouseenter="hover = true" @mouseleave="hover = false" class="toggler">{{sub.completed ? icons[+hover] : icons[+!hover]}}</v-icon>
      <div class="sub-content d-flex">
        <div class="roboto-normal-18 clr-black-38 text-wrap">{{sub.name || "_"}}</div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'Sub',
        components: {

        },
        data() {
          return {
            hover: '',
            icons: ['mdi-eye-off', 'mdi-eye'],
            rename_flag: false,
            name: ''
          }
        },
        props: [
          'sub'
        ],
        computed:{
          ...mapGetters(['current', 'current_task', "picked_sub"]),
          subs(){
            return this.current_task.subs
          }
        },
        methods:{
          rename(){
            this.rename_flag = true
            this.name = this.sub.name
          },
          renameOk(){
            this.renameSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, name: this.name}).then(() => {
              this.rename_flag = false
            })
          },
          del(){
            this.delSub({theme_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id}).then(() => {
              this.rename_flag = false
            })
          },
          toggleCompletedSub() {
            this.setCompletedSub({_id: this.current._id, task_id: this.current_task._id, sub_id: this.sub._id, value: !this.sub.completed})
          },
          startDragSub (evt, item) {
            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('dragSub', JSON.stringify(item))
          }, 
          ...mapActions(['renameSub', 'delSub', 'setCompletedSub'])
        }
    }
</script>

<style lang="scss" scoped>

  .rename_button{
    opacity: 0;
    &:hover{
      opacity: 1;
    }
  }
  .sub_wrapper{
    width: 100%;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.2));
    border-radius: 7px;
    background: #FFFFFF;
    position: relative;
    &.shadowUp {
      background: rgba(248, 248, 248, 1);
      box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    .toggler {
      position: absolute;
      color : gray  !important;
      left: 2px;
      &:hover {
        color: black !important;
      }
    }
    .sub {
      height: 72px;
      .sub-content {
        align-items: center;
        padding: 4px 8px 4px 24px;
        height: 100%;
        div{
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
</style>

<style lang="scss" >
  .sub .v-btn__content span:first-child{
        text-transform: none !important;
  }
</style>